<app-header></app-header>
<main class="body-container">
	<router-outlet></router-outlet>
</main>
<app-footer></app-footer>
<app-loading-screen *ngIf="loadingDisplay.isVisible | async"></app-loading-screen>